import {z} from '@hono/zod-openapi';

import {supplierCatalogPartSchema} from './supplierCatalogPartSchema';

export const supplierCatalogSearchResponseSchema = z
  .object({
    parts: z.array(supplierCatalogPartSchema),
    hasMore: z.boolean(),
  })
  .openapi('SupplierCatalogSearchResponse');
